export default `WITH startCte AS (
  SELECT 
    dataEv 
  FROM 
    ParamsTable 
  WHERE 
    group_nr = ? 
    AND dataEv IS NOT NULL 
  ORDER by 
    dataEv 
  LIMIT 
    1
), insertedCte AS (
  SELECT 
    SUM(
      CASE WHEN key <> 'pigletReclassifyToPorker' THEN value :: INTEGER END
    ):: INTEGER as animals, 
    SUM(
      CASE WHEN key IN (
        'weanedInsertedCnt', 'weanerTransferredTo'
      ) THEN value :: INTEGER END
    ):: INTEGER as weaners, 
    SUM(
      CASE WHEN key IN (
        'giltInsertedCnt', 'giltTransferredTo'
      ) THEN value :: INTEGER END
    ):: INTEGER as gilts, 
    SUM(
      CASE WHEN key IN (
        'finisherInsertedCnt', 'finisherTransferredTo', 
        'pigletReclassifyToPorker'
      ) THEN value :: INTEGER END
    ):: INTEGER as finisher, 
    EPOCH_MS(
      (
        dataEv - (
          dataEv % (1000 * 60 * 60 * 24)
        )
      ):: BIGINT
    )::DATE as date 
  FROM 
    ParamsTable 
  WHERE 
    group_nr = ? 
    AND key IN (
      'weanedInsertedCnt', 'giltInsertedCnt', 
      'finisherInsertedCnt', 'weanerTransferredTo', 
      'giltTransferredTo', 'finisherTransferredTo', 
      'pigletReclassifyToPorker'
    ) 
  GROUP BY 
    dataEv - (
      dataEv % (1000 * 60 * 60 * 24)
    )
), 
transferredFromCte AS (
  SELECT 
    SUM(value :: INTEGER):: INTEGER as animals, 
    SUM(
      CASE WHEN key = 'weanerTransferredFrom' THEN value :: INTEGER END
    ):: INTEGER as weaners, 
    SUM(
      CASE WHEN key = 'giltTransferredFrom' THEN value :: INTEGER END
    ):: INTEGER as gilts, 
    SUM(
      CASE WHEN key = 'finisherTransferredFrom' THEN value :: INTEGER END
    ):: INTEGER as finisher, 
    EPOCH_MS(
      (
        dataEv - (
          dataEv % (1000 * 60 * 60 * 24)
        )
      ):: BIGINT
    )::DATE as date 
  FROM 
    ParamsTable 
  WHERE 
    group_nr = ? 
    AND key IN (
      'weanerTransferredFrom', 'giltTransferredFrom', 
      'finisherTransferredFrom'
    ) 
  GROUP BY 
    dataEv - (
      dataEv % (1000 * 60 * 60 * 24)
    )
), 
removedCte AS (
  SELECT 
    SUM(
      CASE WHEN key <> 'pigletReclassifyToPorker' THEN value :: INTEGER END
    ):: INTEGER as animals, 
    SUM(
      CASE WHEN key = 'weanedPigSellCnt' 
      OR key = 'pigletReclassifyToPorker' THEN value :: INTEGER END
    ):: INTEGER as weaners, 
    SUM(
      CASE WHEN key = 'giltPigSellCnt' THEN value :: INTEGER END
    ):: INTEGER as gilts, 
    SUM(
      CASE WHEN key = 'finisherPigSellCnt' THEN value :: INTEGER END
    ):: INTEGER as finisher, 
    EPOCH_MS(
      (
        dataEv - (
          dataEv % (1000 * 60 * 60 * 24)
        )
      ):: BIGINT
    ) as date 
  FROM 
    ParamsTable 
  WHERE 
    group_nr = ? 
    AND key IN (
      'weanedPigSellCnt', 'giltPigSellCnt', 
      'finisherPigSellCnt', 'pigletReclassifyToPorker'
    ) 
  GROUP BY 
    dataEv - (
      dataEv % (1000 * 60 * 60 * 24)
    )
), 
animalAmountCte AS (
  SELECT 
    COALESCE(insertedCte.date, transferredFromCte.date) as date, 
    ifnull(insertedCte.animals, 0) - ifnull(transferredFromCte.animals, 0) as animals, 
    ifnull(insertedCte.weaners, 0) - ifnull(transferredFromCte.weaners, 0) as weaners, 
    ifnull(insertedCte.gilts, 0) - ifnull(transferredFromCte.gilts, 0) as gilts, 
    ifnull(insertedCte.finisher, 0) - ifnull(transferredFromCte.finisher, 0) as finisher 
  FROM 
    insertedCte FULL 
    OUTER JOIN transferredFromCte ON insertedCte.date = transferredFromCte.date
), 
fallenCte AS (
  SELECT 
    SUM(value :: INTEGER):: INTEGER as animals, 
    SUM(
      CASE WHEN key = 'weanedPigDeathCnt' THEN value :: INTEGER END
    ):: INTEGER as weaners, 
    SUM(
      CASE WHEN key = 'giltPigDeathCnt' THEN value :: INTEGER END
    ):: INTEGER as gilts, 
    SUM(
      CASE WHEN key = 'finisherPigDeathCnt' THEN value :: INTEGER END
    ):: INTEGER as finisher, 
    EPOCH_MS(
      (
        dataEv - (
          dataEv % (1000 * 60 * 60 * 24)
        )
      ):: BIGINT
    ) as date 
  FROM 
    ParamsTable 
  WHERE 
    group_nr = ? 
    AND key IN (
      'weanedPigDeathCnt', 'finisherPigDeathCnt', 
      'giltPigDeathCnt'
    ) 
  GROUP BY 
    dataEv - (
      dataEv % (1000 * 60 * 60 * 24)
    )
), 
datesCte AS (
  SELECT 
    UNNEST(
      generate_series(
        epoch_ms(dataEv :: BIGINT):: DATE, 
        ifnull(epoch_ms(?::BIGINT)::DATE, current_date), 
        INTERVAL '1 DAY'
      )
    ) as date 
  FROM 
    startCte
), 
insertedByDayCte AS (
  SELECT 
    datesCte.date as date, 
    SUM(animals) as animals, 
    SUM(weaners) as weaners, 
    SUM(gilts) as gilts, 
    SUM(finisher) as finisher 
  FROM 
    animalAmountCte 
    RIGHT JOIN datesCte ON animalAmountCte.date <= datesCte.date 
  GROUP BY 
    datesCte.date
), 
fallenByDayCte AS (
  SELECT 
    datesCte.date as date, 
    SUM(animals) as animals, 
    SUM(weaners) as weaners, 
    SUM(gilts) as gilts, 
    SUM(finisher) as finisher 
  FROM 
    fallenCte 
    RIGHT JOIN datesCte ON fallenCte.date <= datesCte.date 
  GROUP BY 
    datesCte.date
), 
removedByDayCte AS (
  SELECT 
    datesCte.date as date, 
    SUM(animals) as animals, 
    SUM(weaners) as weaners, 
    SUM(gilts) as gilts, 
    SUM(finisher) as finisher 
  FROM 
    removedCte 
    RIGHT JOIN datesCte ON removedCte.date <= datesCte.date 
  GROUP BY 
    datesCte.date
), 
joinedCte AS (
  SELECT 
    epoch_ms(insertedByDayCte.date)::BIGINT as time, 
    insertedByDayCte.animals::INTEGER as insertedAnimals, 
    insertedByDayCte.weaners::INTEGER as insertedWeaners, 
    insertedByDayCte.gilts::INTEGER as insertedGilts, 
    insertedByDayCte.finisher::INTEGER as insertedFinisher, 
    ifnull(fallenByDayCte.animals, 0)::INTEGER as fallen, 
    ifnull(fallenByDayCte.weaners, 0)::INTEGER as fallenWeaners, 
    ifnull(fallenByDayCte.gilts, 0)::INTEGER as fallenGilts, 
    ifnull(fallenByDayCte.finisher, 0)::INTEGER as fallenFinisher, 
    ifnull(removedByDayCte.animals, 0)::INTEGER as removedAnimals, 
    ifnull(removedByDayCte.weaners, 0)::INTEGER as removedWeaners, 
    ifnull(removedByDayCte.gilts, 0)::INTEGER as removedGilts, 
    ifnull(removedByDayCte.finisher, 0)::INTEGER as removedFinisher 
  FROM 
    insertedByDayCte 
    INNER JOIN fallenByDayCte ON insertedByDayCte.date = fallenByDayCte.date 
    INNER JOIN removedByDayCte ON insertedByDayCte.date = removedByDayCte.date
) 
SELECT 
  *, 
  fallen / insertedAnimals * 100 as mortality, 
  CASE WHEN insertedWeaners - (removedWeaners + fallenWeaners) <> 0 THEN fallenWeaners / insertedWeaners * 100 ELSE NULL END as weanerMortality, 
  CASE WHEN insertedGilts - (removedGilts + fallenGilts) <> 0 THEN fallenGilts / insertedGilts * 100 ELSE NULL END as giltMortality, 
  CASE WHEN insertedFinisher - (removedFinisher + fallenFinisher) <> 0 THEN fallenFinisher / insertedFinisher * 100 ELSE NULL END as finisherMortality 
FROM 
  joinedCte 
ORDER BY 
  time
`;
